"use strict";

var AjaxDeferred = function () {

  var handleAjaxDeferred = function (layer, controller, page, action, id, id_project, id_conference, id_actor) {
    var data = [];
    data.push({ name: 'upaction', value: 'async' });
    data.push({ name: 'controller', value: controller });
    data.push({ name: 'page', value: page });
    data.push({ name: 'action', value: action });
    data.push({ name: 'id', value: id });
    data.push({ name: 'id_project', value: id_project });
    data.push({ name: 'id_conference', value: id_conference });
    data.push({ name: 'id_actor', value: id_actor });

    $.ajax({
      url: URL,
      type:'POST',
      data: data,
      success: function(data) {
        if (layer) {
          $(layer).html(data);
          Tooltips.init();
        }
      },
      error: function(exception){
        if (layer) {
          $(layer).html('');
        }
        console.log('Exeption:' + JSON.stringify(exception));
      },
      timeout: 5000 // sets timeout to 5 seconds
    });
  };

  return {
    init: function(layer, controller, page, action, id, id_project, id_conference, id_actor) {
      handleAjaxDeferred(layer, controller, page, action, id, id_project, id_conference, id_actor);
    }
  };

}();

// webpack support
if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = AjaxDeferred;
}